import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

import { formattedError } from '@helpers/functions';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import {
    DataColab,
    FuncaoColaboradorProjeto,
    MembroContratado,
    Projeto,
} from '../models';
import { Information } from '../types';
import { TokenService } from './token.service';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    private url: string = environment.apiUrl;
    showmenu = new EventEmitter<boolean>();

    colaborador = {};

    cache_info = {};

    constructor(
        private http: HttpClient,
        public router: Router,
        private toastr: ToastrService,
        private tokenService: TokenService
    ) {}

    clearCurrent() {
        this.colaborador = {};
    }

    // function to view, edit or create User
    userCrud(user: any, option: string) {
        const i = 'usercrud/';
        if (option === 'post') {
            return this.http.post(this.url + i, user);
        } else if (option === 'get') {
            return this.http.get(this.url + i);
        } else return of(null);
    }

    // function to view,edit or create colaborador
    colaboradorCrud(colaborador: any, option: string) {
        if (option === 'post') {
            return this.http.post(`${this.url}colaboradorcrud/`, colaborador);
        } else if (option === 'get') {
            return this.http.get(`${this.url}colaboradorcrud/`);
        } else return of(null);
    }

    updateColaborador(colaborador) {
        return this.http
            .put<any>(
                `${this.url}colaboradorcrud/` +
                    `${colaborador.id_colaborador}/`,
                colaborador
            )
            .pipe(
                tap(res =>
                    console.log(
                        `atualizou os dados do colaborador ${colaborador.id_colaborador}`
                    )
                )
            );
    }

    getColaboradorById(id) {
        return this.http.get<DataColab>(
            `${this.url}colaboradorcrud/` + `${id}/`
        );
    }

    getEndereco(id = null) {
        if (this.colaborador['endereco']) {
            return of(this.colaborador['endereco']);
        } else {
            let v;
            if (id) {
                v = `colaboradoresenderecos/${id}/`;
            } else {
                v = 'colaboradoresenderecos/';
            }
            return this.http.get<any>(this.url + v).pipe(
                tap(res => {
                    console.log('leu o endereco');
                    this.colaborador['endereco'] = res;
                })
            );
        }
    }

    // function to view or create address in the api
    addressCrud(address: any, option: string) {
        const j = 'enderecocrud/';
        if (option === 'post') {
            return this.http.post(this.url + j, address);
        } else if (option === 'get') {
            return this.http.get(this.url + j);
        } else return of(null);
    }

    // function to get auxdata: paises,ufs,cidades,tp_vinculo,maiorFormacao
    getAuxData() {
        return this.http.get(this.url + 'dados/');
    }

    getEquipe(id = null): Observable<MembroContratado[]> {
        let v;
        if (id) {
            v = `colaboradoresvinculos/${id}/`;
        } else {
            v = 'colaboradoresvinculos/';
        }

        return this.http
            .get<MembroContratado[]>(this.url + v)
            .pipe(tap(res => console.log('leu equipeprojeto')));
    }

    getEquipeProjetoById(id): Observable<MembroContratado> {
        const v = `projetos/equipeprojetocrud/${id}/`;

        return this.http
            .get<MembroContratado>(this.url + v)
            .pipe(tap(res => console.log('leu equipeprojeto')));
    }

    getProjetoById(id): Observable<Projeto> {
        const v = `projetocrud/${id}/`;

        return this.http
            .get<Projeto>(this.url + v)
            .pipe(tap(res => console.log('leu projeto ' + id)));
    }

    getFuncaoColaboradorProjetoById(id): Observable<FuncaoColaboradorProjeto> {
        return this.http
            .get<FuncaoColaboradorProjeto>(
                this.url + `projetos/funcaocolaboradorcrud/${id}/`
            )
            .pipe(tap(res => console.log('leu FuncaoColaborador ' + id)));
    }

    getProjetos(id = null): Observable<any> {
        if (id) {
            return this.http
                .get<Projeto>(`${this.url}projetos/projetosdadosbasicos/${id}/`)
                .pipe(tap(res => console.log('leu projeto')));
        } else {
            return this.http
                .get<Projeto[]>(`${this.url}projetos/projetosdadosbasicos/`)
                .pipe(tap(res => console.log('leu projetos')));
        }
    }

    getFuncaoColaboradorProjeto(): Observable<FuncaoColaboradorProjeto[]> {
        return this.http
            .get<FuncaoColaboradorProjeto[]>(
                this.url + 'projetos/funcaocolaboradorcrud/'
            )
            .pipe(tap(res => console.log('leu funcaocolaborador')));
    }

    getTpVinculo(): Observable<any> {
        return this.http
            .get(this.url + 'get_tpvinculo/')
            .pipe(tap(res => console.log('leu os TpVinculos')));
    }

    getTpVinculoById(id): Observable<any> {
        const v = `get_tpvinculo/${id}/`;

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu os TpVinculo ' + id)));
    }

    getTpFormacao(id): Observable<any> {
        let v;
        if (id) {
            v = `tpformacaocrud/${id}/`;
        } else {
            v = 'tpformacaocrud/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu os tpformacao')));
    }

    getAreaConhecimento(id): Observable<any> {
        let v;
        if (id) {
            v = `areaconhecimentocrud/${id}/`;
        } else {
            v = 'areaconhecimentocrud/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu os areaconhecimento')));
    }

    getGrandeAreaConhecimento(id): Observable<any> {
        let v;
        if (id) {
            v = `grandesareaconhecimentocrud/${id}/`;
        } else {
            v = 'grandesareaconhecimentocrud/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu os areaconhecimento')));
    }

    getPaises(id = null): Observable<any> {
        let v;
        if (id) {
            v = `get_pais/${id}/`;
        } else {
            v = 'get_pais/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu os paises')));
    }

    getUfs(id = null): Observable<any> {
        let v;
        if (id) {
            v = `get_ufs/${id}/`;
        } else {
            v = 'get_ufs/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu as ufs')));
    }

    getPaisesById(id): Observable<any> {
        const v = `get_pais/${id}/`;

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu o pais ' + id)));
    }

    getCidades(id = null): Observable<any> {
        let v;
        if (id) {
            v = `get_cidades/${id}/`;
        } else {
            v = 'get_cidades/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu as cidades')));
    }

    getEstados(id = null): Observable<any> {
        let v;
        if (id) {
            v = `get_ufs/${id}/`;
        } else {
            v = 'get_ufs/';
        }

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu estados')));
    }

    getCidadesById(id): Observable<any> {
        const v = `get_cidades/${id}/`;

        return this.http
            .get(this.url + v)
            .pipe(tap(res => console.log('leu as cidade ' + id)));
    }

    getBairros(id = null) {
        let v;
        if (id) {
            v = `bairroscrud/${id}/`;
        } else {
            v = 'bairroscrud/';
        }
        return this.http
            .get<any>(this.url + v)
            .pipe(tap(res => console.log('leu bairros')));
    }

    getBancos(id = null) {
        let v;
        if (id) {
            v = `bancocrud/${id}/`;
        } else {
            v = 'bancocrud/';
        }
        return this.http
            .get<any>(this.url + v)
            .pipe(tap(res => console.log('leu bancos')));
    }

    getConta(id = null) {
        if (this.colaborador['conta']) {
            return of(this.colaborador['conta']);
        } else {
            let v;
            if (id) {
                v = `financas/colaboradoresdadosbancarios/${id}/`;
            } else {
                v = 'financas/colaboradoresdadosbancarios/';
            }
            return this.http.get<any>(this.url + v).pipe(
                tap(res => {
                    console.log('leu contas');
                    this.colaborador['conta'] = res;
                })
            );
        }
    }

    getOcorrencias(id = null) {
        let v;
        if (id) {
            v = `colaboradoresocorrencias/${id}/`;
        } else {
            v = 'colaboradoresocorrencias/';
        }
        return this.http
            .get<any>(this.url + v)
            .pipe(tap(res => console.log('leu ocorrencias')));
    }

    getTpConta(id = null) {
        let v;
        if (id) {
            v = `tpcontacrud/${id}/`;
        } else {
            v = 'tpcontacrud/';
        }
        return this.http
            .get<any>(this.url + v)
            .pipe(tap(res => console.log('leu tpconta')));
    }

    getFormacao(id = null) {
        if (this.colaborador['formacao']) {
            return of(this.colaborador['formacao']);
        } else {
            return this.http
                .get<any>(
                    `${this.url}colaboradoresformacao/${id ? id + '/' : ''}`
                )
                .pipe(
                    tap(res => {
                        console.log('leu formacoes');
                        this.colaborador['formacao'] = res;
                    })
                );
        }
    }

    reciboPdfObject(id) {
        const { token } = this.tokenService.get();
        return {
            url: this.url + `reciboeletronico/${id}/`,
            end_documento: `/api/reciboeletronico/${id}/`,
            httpHeaders: { Authorization: `JWT ${token}` },
        };
    }

    relatorioViagemPdfObject(id) {
        const { token } = this.tokenService.get();
        return {
            url: this.url + `suprimentos/relatorioviagem/${id}/`,
            httpHeaders: { Authorization: `JWT ${token}` },
        };
    }

    async relatorioViagemBLOB(id): Promise<Blob> {
        const options = this.relatorioViagemPdfObject(id);
        const file = await this.http
            .get(options.url, {
                headers: options.httpHeaders,
                responseType: 'blob',
            })
            .toPromise();
        return file;
    }

    assinaRecibo(data) {
        return this.http.patch<any[]>(
            `${this.url}reciboeletronico/${data['id']}/`,
            data
        );
    }

    information(idTpDocumento: number): Observable<Information> {
        if (idTpDocumento === undefined)
            return throwError({
                message: '[api/documentos/regras/] id_tp_documento is null',
            });
        if (this.cache_info[idTpDocumento])
            return of(this.cache_info[idTpDocumento]);
        return this.http
            .get<Information>(`${this.url}documentos/regras/${idTpDocumento}/`)
            .pipe(tap(res => (this.cache_info = res)));
    }

    public async downloadResource(url): Promise<Blob> {
        const { token } = this.tokenService.get();
        const file = await this.http
            .get<Blob>(url, {
                responseType: 'blob' as 'json',
                headers: {
                    Authorization: `JWT ${token}`,
                },
            })
            .pipe(
                catchError(err => {
                    err['error'].text().then(txt => {
                        this.toastr.error('Erro ao efetuar o download');
                        console.error(formattedError(txt));
                    });
                    return of(err['error']);
                })
            )
            .toPromise();
        return file;
    }
}
